import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 537.9 506"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M404.8 236.8H296.9l64-110.8h-37.4l-54.6 94.6-54.6-94.6h-37.4l64 110.8H133v32.4h107.9L177 379.9h37.4l54.6-94.5 54.6 94.5H361l-63.9-110.7H405v-32.4Zm-109.5 31.4L269 283.4l-26.3-15.2v-30.4l26.3-15.2 26.3 15.2z",
      style: {"fill-rule":"evenodd","fill":"currentColor"}
    }, null, -1)
  ]))]))
}
export default { render: render }